import React from 'react'

import PrimaryView from "./PrimaryView"
import TransactionDetailsSidebar from "./TransactionDetailsSidebar"

const BankReconciliationPageView = ({
  isSidebarOpen = false,
  ...logic
} = {}) => {
  return (
    <div className="App" style={{ display: "flex" }}>
      <div style={{ flex: 1 }}>
        <PrimaryView
          {...logic}
        />
      </div>
      {!!isSidebarOpen && (
        <TransactionDetailsSidebar
          {...logic}
        />
      )}
    </div>
  )
}

export default BankReconciliationPageView
